module.exports = __webpack_public_path__ + "static/media/github-white.f2f9ce32.png";